<template>
    <div>
        <el-dialog
            title=""
            :visible="dialogVisible"
            :before-close="handleClose"
            width="30%" height="65%">
            <template>
                <div class="flex column aic jca mb20">
                    <img src="../../assets/succeed.png" alt="" class="flex0 width20">
                    <span class="mt20">预约成功</span>
                    <span class="mt80">预约信息已短信发送至{{mobile || 12345567777}}</span>
                    <div class="load_btn pl20 pr20 pt10 pb10 pointer mt80" @click="showEditDia">补充患者病历资料</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog
                :visible="editVisible"
                width="50%"
                :before-close="editClose"
                center>
            <span class="editHeader">*请上传患者病历资料，将辅助协作医生为患者做全面的病情评估</span>
            <el-form ref="form" :model="editForm" label-width="80px" class="mt30">
                <el-form-item label="病情描述:">
                    <el-input type="textarea" v-model="editForm.bqms" :autosize="{ minRows: 2, maxRows: 7}" :maxlength="500" placeholder="请输入病情内容最多输入200字..."></el-input>
                </el-form-item>
                <el-form-item label="所患疾病:">
                    <el-input type="textarea" v-model="editForm.shjb" placeholder="请输入所患疾病..."></el-input>
                </el-form-item>
                <el-form-item label="既往史:">
                    <el-input type="textarea" v-model="editForm.jhs" placeholder="请输入既往史..."></el-input>
                </el-form-item>
                <el-form-item label="家族史:">
                    <el-input type="textarea" v-model="editForm.jzs" placeholder="请输入家族史..."></el-input>
                </el-form-item>
                <el-form-item label="过敏史:">
                    <el-input type="textarea" v-model="editForm.gms" placeholder="请输入过敏史..."></el-input>
                </el-form-item>
                <el-form-item label="图片资料:">
                    <span class="imageInfo">(化验单、影像等资料不超过9张)</span>
                    <hos_flie_load :onlyImg="false" ref="editRef"></hos_flie_load>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="loadJump">跳 过</el-button>
                    <el-button type="primary" @click="loadSucc" style="margin-left:100px !important">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog
                :visible="succVisible"
                width="30%"
                :before-close="succClose"
                center>
           <div class="dilog mt100 flex jcc aic">
               <div class="pb100">
                   <div class="flex aic jcc">
                       <div style="text-align: center">
                           <img :src="successIcon">
                           <p class="pt30">患者资料提交成功</p>
                       </div>
                   </div>
                   <div class="goApply flex jcc aic mt100 pointer" @click="goApply">
                       申请列表
                   </div>
               </div>
           </div>

        </el-dialog>
    </div>
</template>

<script>
    import hos_flie_load from "../../components/hos/hos-flie-load"
    import {isEmpty} from "../../lib/utils"
  export default {
    name: "succeed-dialog",
    props: {
      mobile: String
    },
      components:{hos_flie_load},
    data() {
      return {
        dialogVisible: false,
          editVisible:false,
          succVisible:false,
          successIcon:require("../../assets/yygh.png"),
        form: {
          systemScore: ''
        },
          editForm:{
              bqms:"",
              shjb:"",
              jhs:"",
              jzs:"",
              gms:"",
              attaList:[]
          }
      }
    },
    methods: {
      show() {
        this.dialogVisible = true;
      },
      hide() {
        this.dialogVisible = false;
      },
      handleClose(){
        this.$emit('close')
      },
        //现实补充资料弹框
        showEditDia(){
            this.dialogVisible = false;
            this.editVisible = true;
        },
        loadSucc(){
          let vail = false
          for(let obj in this.editForm){
              if(typeof this.editForm[obj] != Array){
                  if(!isEmpty(this.editForm[obj])){
                      vail = true;
                  }
              }
          }
            if(!vail){
                this.$message.error('至少需要填写一条记录。');
                return
            }
          //上传的图片id列表
          let attaList = this.$refs['editRef'].getAttaList();
          this.editForm.attaList = attaList.attaIdList;
            this.editVisible = false;
            this.$emit('supplement',this.editForm);
        },
        editClose(){
            this.editVisible = false;
        },
        loadJump(){
            this.editVisible = false;
            this.$router.push("/main/referral/dis/distance/launch");
        },
        showSuccsee(){
          this.succVisible = true;
        },
        goApply(){
            this.succVisible = false;
            this.$router.push("/main/referral/dis/distance/launch");
        },
        succClose(){
            this.succVisible = false;
            this.$router.push("/main/referral/dis/distance/launch");
        }
    },
  }
</script>

<style scoped>
.load_btn{
    background: #3692F9;
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
}
    .editHeader{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #FF0000;
    }
    .imageInfo{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #999999;
    }
    .dilog{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
    }
    .goApply{
        background: #3692F9;
        border-radius: 2px;
        width:174px;
        height: 32px;
        color: #ffffff;
    }
</style>
